import { render } from "./FeatureCard.vue?vue&type=template&id=65c1d278&ts=true"
import script from "./FeatureCard.vue?vue&type=script&lang=ts"
export * from "./FeatureCard.vue?vue&type=script&lang=ts"

import "./FeatureCard.vue?vue&type=style&index=0&id=65c1d278&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__